var map = {
	"./1minute.svg": 713,
	"./24.svg": 714,
	"./AlmaLinux.svg": 715,
	"./Customers/VPS-foods.jpg": 690,
	"./Customers/VPS-khandevane.jpg": 691,
	"./Customers/VPS-manufacturing-firms.jpg": 692,
	"./Customers/VPS-sunich.jpg": 693,
	"./Feature-3.svg": 716,
	"./Feature-4.svg": 717,
	"./Feature-5.svg": 718,
	"./Feature-8.svg": 719,
	"./Fedora.svg": 720,
	"./Google.svg": 721,
	"./HA.svg": 722,
	"./Isolation.svg": 723,
	"./P1.png": 724,
	"./P2.png": 725,
	"./P3.png": 726,
	"./P4.png": 727,
	"./P5.png": 728,
	"./PfSense.svg": 729,
	"./Rocky_Linux.svg": 730,
	"./Step1-m.svg": 731,
	"./Step1.svg": 732,
	"./Step2-m.svg": 733,
	"./Step2.svg": 734,
	"./Step3.svg": 735,
	"./Successful-Google-Cloud-Migration-1440x564_c 1.svg": 736,
	"./VPS_Info_.svg": 737,
	"./ads1.svg": 738,
	"./ads2.svg": 739,
	"./apache.svg": 740,
	"./architect.svg": 741,
	"./backup.svg": 742,
	"./calc.png": 743,
	"./centos.svg": 744,
	"./chooseOs.svg": 745,
	"./common-types.svg": 746,
	"./console.svg": 747,
	"./container.svg": 748,
	"./dashboard.svg": 749,
	"./ddos-c.svg": 750,
	"./ddos-d.svg": 751,
	"./ddos.svg": 752,
	"./debian.svg": 753,
	"./disaster.svg": 754,
	"./docker.svg": 755,
	"./everything.svg": 756,
	"./externalServer.svg": 757,
	"./firewall-new.svg": 758,
	"./firewall.png": 759,
	"./freeSupport.svg": 760,
	"./global.svg": 761,
	"./hq.svg": 762,
	"./iaas_catalogue.png": 763,
	"./ico.png": 764,
	"./image1.svg": 765,
	"./increase.svg": 766,
	"./infrustructure.svg": 767,
	"./ip.png": 768,
	"./iranServer.svg": 769,
	"./list-vps.svg": 770,
	"./mikrotik.svg": 771,
	"./mysql.svg": 772,
	"./nStep1-m.svg": 710,
	"./nStep1.svg": 711,
	"./nginx.svg": 773,
	"./nodejs.svg": 774,
	"./not-found-mobile.svg": 775,
	"./not-found.svg": 776,
	"./panel.svg": 777,
	"./pattern.png": 778,
	"./plans.svg": 779,
	"./plans/Maple.svg": 677,
	"./plans/Willow.svg": 678,
	"./plans/beech.svg": 679,
	"./plans/cedar.svg": 680,
	"./plans/pine.svg": 681,
	"./plans/poplar.svg": 682,
	"./platform.png": 780,
	"./platform2.png": 781,
	"./python.svg": 782,
	"./resource.svg": 783,
	"./service-mgs.svg": 784,
	"./service-vpc.svg": 704,
	"./service-vps.svg": 705,
	"./service.svg": 785,
	"./siem.svg": 786,
	"./sla.svg": 787,
	"./startup.svg": 788,
	"./support.svg": 789,
	"./test.svg": 790,
	"./top-ways.svg": 791,
	"./traffic-vps.svg": 792,
	"./ubuntu18.svg": 793,
	"./ubuntu22.svg": 794,
	"./uptime.svg": 795,
	"./video.png": 796,
	"./vps-header.svg": 689,
	"./vps-hourly.svg": 706,
	"./vps-platform.png": 797,
	"./vps1.png": 798,
	"./vps10.png": 799,
	"./vps2.png": 800,
	"./vps3.png": 801,
	"./vps4.png": 802,
	"./vps5.png": 803,
	"./vps6.png": 804,
	"./vps7.png": 805,
	"./vps8.png": 806,
	"./vps9.png": 807,
	"./vps_figure.png": 808,
	"./vps_icon.png": 683,
	"./vps_picture2.png": 809,
	"./vpspackage.png": 810,
	"./waf-c.svg": 811,
	"./waf-d.svg": 812,
	"./waf-icon-active.svg": 813,
	"./waf-icon.svg": 814,
	"./waf-vps.svg": 815,
	"./waf.svg": 816,
	"./windows.svg": 817,
	"./wordpress.svg": 818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671;